<template>
    <div class="report-details-selector" :class="{ 'list-mode': !isCompact }">
        <div class="selected__wrapper">
            <span class="p-d-flex p-ai-center p-jc-md-between" style="gap: 0.75rem;">
                <small style="margin-right: 2rem;">Select Report Details</small>
                <InputSwitch v-model="allDetailsSelected" @change="toggleSelectedDetails" />
                <span>{{ selectAllDetailsstext }}</span>
            </span>
        </div>
        <div class="detail__checkbox--wrapper">
            <div v-for="detail in detailsList" :key="detail.value" class="detail__checkbox">
                <Checkbox :name="detail.value" :value="detail.value" v-model="selectedDetails" @change="updateDetailsStore">
                </Checkbox>
                <label :for="detail.value">{{ detail.label }}</label>
            </div>
            <!-- added below to fill out the grid -->
            <div class="detail__checkbox"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        details: {
            type: Array,
            default: () => [
                { value: 'site_id', label: 'Site' },
                { value: 'full_name', label: 'Full Name' },
                { value: 'company', label: 'Company' },
                { value: 'date', label: 'Date / Time' },
                { value: 'status', label: 'Status' },
            ]
        },
        isCompact: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            selectAllDetailsstext: 'Select All',
            // allDetailsSelected: false,
            selectedDetails: [] 
        }
    },

    computed: {
        detailsList() {
            return this.details
        },
        allDetailsSelected() {
            const selectedDetails = this.$store.getters['createCustomReport/getSelectedReportDetails']
            return selectedDetails.length === this.details.length
        }
    },

    mounted() {
        this.selectedDetails = this.$store.getters['createCustomReport/getSelectedReportDetails']
    },

    methods: {
        toggleSelectedDetails() {
            if (this.selectedDetails.length != this.details.length) {
                this.selectedDetails = this.details.map((detail) => detail.value)
            } else {
                this.selectedDetails = []
            }

            this.updateDetailsStore()
        },

        async updateDetailsStore() {
            this.$store.dispatch('createCustomReport/selectReportDetails', this.selectedDetails)
        }
    }
}
</script>

<style lang="scss" scoped>
.selected__wrapper {
    width: fit-content;
    padding: 1rem;
    padding-bottom: 0;
}

.detail__checkbox {
    display: flex;
    gap: 0.5rem;
    padding: 0.5rem 0.25rem;

    @media only screen and (min-width: 801px) {

        &:nth-child(6n+1),
        &:nth-child(6n+2),
        &:nth-child(6n+3) {
            background-color: #fafafa;
        }

        &:nth-child(6n+4),
        &:nth-child(6n+5),
        &:nth-child(6n+6) {
            background-color: #fff;
        }
    }

    &--wrapper {
        padding: 1rem;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media only screen and (max-width: 800px) {
        &--wrapper {
            padding: 1rem;
            display: grid;
            grid-template-columns: repeat(1, minmax(0, 1fr));
        }

        &:nth-of-type(odd) {
            background-color: #fafafa;
        }
    }
}

.detail__checkbox:has(.p-checkbox-disabled) {
    opacity: 0.6;
}

// List mode styles
.list-mode {
    .detail__checkbox--wrapper {
        grid-template-columns: repeat(1, minmax(0, 1fr));
        grid-template-rows: repeat(2, minmax(0, 1fr));

        .detail__checkbox {

            padding: 1rem 0.5rem;

            &:nth-of-type(odd) {
                background-color: #fafafa;
            }

            &:nth-of-type(even) {
                background-color: #fff;
            }

            &:last-of-type {
                display: none;
            }
        }
    }
}
</style>